<template>
    <div v-bind="{ style }">
        <slot />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters("employment/form/page", ["width"]),

        style() {
            let scale = this.width / 784;
            return {
                position: "absolute",
                right: "50%",
                bottom: "50%",

                transform: `translate(50%, 50%) scale(${scale})`,

                width: `${100 * (1 / scale)}%`,
                height: `${100 * (1 / scale)}%`,
            };
        },
    },
};
</script>

<style></style>
